import type { DataNode } from 'antd/es/tree';
import { useMemo } from 'react';

import type { CropSeasonOption } from '../../../hooks/types';
import {
  ACTIVE_SECTION_KEY,
  INACTIVE_SECTION_KEY,
  SHOW_MORE_KEY
} from '../constants';

interface Props {
  activeOptions: CropSeasonOption[];
  inactiveOptions: CropSeasonOption[];
  searchValue: string;
  inactiveLimit: number;
}

const useCropSeasonTreeData = ({
  activeOptions,
  inactiveOptions,
  searchValue,
  inactiveLimit
}: Props) =>
  useMemo(() => {
    const displayedInactiveOptions = searchValue
      ? inactiveOptions
      : inactiveOptions.slice(0, inactiveLimit);
    const nodes: DataNode[] = [];

    if (activeOptions.length > 0) {
      nodes.push({
        key: ACTIVE_SECTION_KEY,
        title: 'Active Seasons',
        selectable: false,
        checkable: false,
        className: 'season-section-node',
        children: activeOptions.map(option => ({
          key: option.value,
          title: option.label
        }))
      });
    }

    if (displayedInactiveOptions.length > 0) {
      const inactiveChildren: DataNode[] = displayedInactiveOptions.map(
        option => ({
          key: option.value,
          title: option.label
        })
      );

      if (!searchValue && inactiveLimit < inactiveOptions.length) {
        inactiveChildren.push({
          key: SHOW_MORE_KEY,
          title: 'Show more',
          selectable: false,
          checkable: false
        });
      }

      nodes.push({
        key: INACTIVE_SECTION_KEY,
        title: 'Inactive Seasons',
        selectable: false,
        checkable: false,
        className: activeOptions.length ? 'season-section-divider' : undefined,
        children: inactiveChildren
      });
    }

    return nodes;
  }, [activeOptions, inactiveOptions, searchValue, inactiveLimit]);

export default useCropSeasonTreeData;
